import { Injectable } from '@angular/core';
import { GenericConfig } from './config.generic';

/**
 * Created by dimah on 07/06/17.
 */
 @Injectable({
   providedIn: 'root'
})
 export class RestUrlsConfig {

    static readonly FESD  = "fe";  // frontend sub-domain
    static readonly APPSD = "app"; // app sub-domain
    static readonly DEV_ENV_REGEXP = /\w+\.d\..+\.signature-it\.com$/;

    // TODO: change to use environment variables
    private _dev = GenericConfig.isWebComponent ? false:  RestUrlsConfig.DEV_ENV_REGEXP.test(location.hostname);

    constructor() {
        RestUrlsConfig._findCurrentDomain();
    }

    get appURL(): string {
        const _appUrl = GenericConfig.appURL || '';
        if (_appUrl) {
            return (_appUrl.startsWith('http') || _appUrl.startsWith('/')) ? _appUrl : `${location.protocol}//${_appUrl}`;
        }
        let rgx = new RegExp(`(?!:\/\/)${RestUrlsConfig.FESD}`);
        return location.origin.match(/(\w+)\.fe/) ?
            location.origin.replace(location.origin.match(new RegExp(`(\\w+).${RestUrlsConfig.FESD}`))[0], RestUrlsConfig.APPSD):
            location.origin.replace(rgx, RestUrlsConfig.APPSD);
    }

    get feURL(): string {
        return GenericConfig.feURL || '';
    }

    get beURL(): string {
        const _beUrl = GenericConfig.beURL || '';
        if (_beUrl) { 
            return (_beUrl.startsWith('http') || _beUrl.startsWith('/')) ? _beUrl : `${location.protocol}//${_beUrl}`;
        }
        let rgx = this.fePrefix;
        return location.origin.match(/(\w+)\.fe/) ?
            location.origin.replace(location.origin.match(new RegExp(`(\\w+).${rgx}`))[0], ''):
            location.origin.replace(new RegExp(`(?!:\/\/)${rgx}`), '');
    }

    get apiBeURL(): string {
        return GenericConfig.apiBeURL ? GenericConfig.apiBeURL : `${this.beURL}/api`;
    }

    get domain(): string {
        return location.hostname.match(/\.\w+\.(.*)/) ? location.hostname.match(/\.\w+\.(.*)/)[0]: '';
    }

    get ssoDomain(): string {
        const _ssoDomain = GenericConfig.ssoDomain || '';
        if (_ssoDomain) {
            return _ssoDomain;
        }
        if(GenericConfig.isWebComponent) {
            return this.domain;
        }
        const r = new RegExp(`^(${RestUrlsConfig.FESD})(\\.|-)(.*)`);
        const match = location.hostname.match(r);
        if (match) {
            return this.dev ? location.hostname.match(RestUrlsConfig.DEV_ENV_REGEXP)[0] : match[3]
        }
        return this.domain;
    }

    get fePrefix() {
        return (this._dev)
        ? `${RestUrlsConfig.FESD}-`
        : `${RestUrlsConfig.FESD}.`;
    }

    get dev(): boolean {
        return this._dev;
    }

    private static _findCurrentDomain() {
        if (!GenericConfig.siteDomains) return;
        for (const domain in GenericConfig.siteDomains) {
            if (domain == location.hostname) {
                Object.entries(GenericConfig.siteDomains[domain]).forEach(entry => {
                    const [key, value] = entry;
                    GenericConfig.setValue(key, value);
                })
            }
        }
    }
}
